import { Text, FilterChip } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledText = styled(Text)`
  white-space: nowrap;
`
export const StyledFilterChip = styled(FilterChip)`
  & > div > div > div {
    background-color: inherit !important;
  }
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #ccc;
`
